module.exports = __webpack_public_path__ + "static/media/kr.2a183310.svg";